export const getPayloadFromJWT = (jwt: string): { sub: string; iat: number } =>
  JSON.parse(Buffer.from(jwt.split('.')[1], 'base64').toString('utf8'))
